import { proCustomerNote } from '@/lib/proCustomerNote.mjs';

// הערת מומחה ללקוח (Founder 30/09/26) — the admin-set note shown next to the pro's contact buttons. Text comes ONLY through
// lib/proCustomerNote.mjs (the same door the WhatsApp cards use); empty → renders nothing. Server-safe (no hooks).
export default function ProCustomerNote({ note, className = '' }: { note?: string | null; className?: string }) {
  const text = proCustomerNote(note);
  if (!text) return null;
  return (
    <p data-pro-customer-note className={`flex items-start gap-1.5 rounded-xl text-sm font-semibold leading-snug ${className}`}
      style={{ background: '#eff6ff', border: '1px solid #bfdbfe', color: '#1e3a8a', padding: '8px 10px', textAlign: 'start' }}>
      <span aria-hidden="true" style={{ flexShrink: 0 }}>ℹ️</span>
      <span>{text}</span>
    </p>
  );
}
